import styled from "styled-components"

export const PressReleaseDetailsContainer = styled.div`
  a {
    color: ${props => props.theme.colors.darkBlue};
    text-decoration: none;
  }
  svg {
    font-size: 32px;
    margin-bottom: 20px;
    color: ${props => props.theme.colors.brightBlue};
  }
  padding: 80px 0;
  h1 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 25px;
  }
  .press-release-title {
    color: ${props => props.theme.colors.brightBlue};
    max-width: 1000px;
    margin-bottom: 40px;
  }
  p {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 15px;
    strong,
    b {
      font-weight: bold;
      color: ${props => props.theme.colors.darkBlue};
    }
    a {
      text-decoration: none;
      color: ${props => props.theme.colors.brightBlue};
    }
    span {
      color: ${props => props.theme.colors.darkBlue};
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 15px;
    color: ${props => props.theme.colors.darkBlue};
  }
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
